<template>
  <el-main>
    <!-- #region 培訓參數-->
    <el-row>
      <el-col :span="12" :offset="6">
        <div class="block-div">
          <el-row>
            <el-col style="font-size:20px" :span="12">
              培訓參數
            </el-col>
            <el-col align="right" :span="12">
              <el-button
                type="primary"
                @click="TrainingRecordUpdateExpiryDateAPI()"
                >儲存</el-button
              >
            </el-col>
          </el-row>
          <el-row style="margin:24px 0">
            <el-col>
              <el-input
                v-model="trainingRecoredYear"
                style="width:40px"
              ></el-input>
              年內，須報名考證(須付費與擁有准考證)，否則培訓資格失效。
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <!-- #endregion -->

    <!-- #region 複訓參數-->
    <el-row>
      <el-col :span="12" :offset="6">
        <div class="block-div">
          <el-row>
            <el-col style="font-size:20px" :span="12">
              複訓參數
            </el-col>
            <el-col align="right" :span="12">
              <el-button
                type="primary"
                @click="ReTrainingRecordUpdateExpiryDateAPI()"
                >儲存</el-button
              >
            </el-col>
          </el-row>
          <el-row style="margin:24px 0">
            <el-col
              >取得證照後
              <el-input
                v-model="reTrainingRecoredYear"
                style="width:40px"
              ></el-input>
              年內，須參加複訓，否則證照失效。(複訓由後台人員確認後新增紀錄)</el-col
            >
          </el-row>
        </div>
      </el-col>
    </el-row>
    <!-- #endregion -->

    <!-- #region 說明-->
    <el-row style="color: #606266;">
      <el-col :span="12" :offset="6">
        <div style="margin-left:8px">
          <li>
            兩項參數若無需時間限制，請輸入【0】即可。
          </li>
          <li>
            請逐一修改完後並按儲存
          </li>
        </div>
      </el-col>
    </el-row>
    <!-- #endregion -->
  </el-main>
</template>

<script>
import {
  C_ExpiryDate_Get,
  C_TrainingRecord_UpdateExpiryDate,
  C_ReTrainingRecord_UpdateExpiryDate,
} from '@/assets/js/api';

export default {
  data() {
    return {
      trainingRecoredYear: 0,
      reTrainingRecoredYear: 0,
    };
  },
  mounted() {
    this.ExpiryDateGetAPI();
  },
  methods: {
    // GET API
    ExpiryDateGetAPI() {
      C_ExpiryDate_Get()
        .then((res) => {
          this.trainingRecoredYear = res.data.data.trainingYear;
          this.reTrainingRecoredYear = res.data.data.reTrainingYear;
        })
        .catch((err) => {
          this.$notify({
            title: '失敗',
            message: err.response.data.message,
            type: 'error',
          });
        });
    },
    // 更新培訓時效API
    TrainingRecordUpdateExpiryDateAPI() {
      C_TrainingRecord_UpdateExpiryDate(this.trainingRecoredYear)
        .then(() => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
          });
        })
        .catch((err) => {
          this.$notify({
            title: '失敗',
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.ExpiryDateGetAPI();
        });
    },
    // 更新"複訓"時效API
    ReTrainingRecordUpdateExpiryDateAPI() {
      C_ReTrainingRecord_UpdateExpiryDate(this.reTrainingRecoredYear)
        .then(() => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
          });
        })
        .catch((err) => {
          this.$notify({
            title: '失敗',
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.ExpiryDateGetAPI();
        });
    },
  },
};
</script>

<style scoped>
.block-div {
  padding: 24px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #0089fa10;
  margin: 20px 0;
}
</style>
